import {
  Box,
  Typography,
  Grid,
  InputLabel,
  Tooltip,
  TextField,
} from '@mui/material';
import MultiSelectChip from '../Custom Components/MultiSelectChip/MultiSelectChip';
import { Info } from '@mui/icons-material';

const ConsultantsTabBlock = ({
  blockDetail,
  handleAnswerSubmit = () => {},
  dataHandler = () => {},
}) => {
  return (
    <Box mt={2} ml={2}>
      <Grid container columnSpacing={2}>
        {blockDetail?.map((blockOption, index) => {
          if (blockOption.status === true || blockOption.status === null || blockOption.status === undefined) {
            return (
              <Grid key={'blockOption' + index} item mb={2} xs={12} lg={6}>
                <InputLabel
                  sx={{ overflow: 'visible' }}
                  htmlFor={blockOption?.question}
                  shrink={false}
                  className="dashboardLabel1"
                >
                  <Typography
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      whiteSpace: 'break-spaces',
                    }}
                  >
                    {blockOption?.question}
                    {blockOption?.toolTip && (
                      <Tooltip title={blockOption?.toolTip}>
                        <Info fontSize="small" sx={{ marginLeft: 1 }} />
                      </Tooltip>
                    )}
                  </Typography>
                </InputLabel>
                {blockOption?.type === 'text' || blockOption?.type === 'textarea' || blockOption?.type === 'textField' || blockOption?.type === 'textFieldMulti' ? (
                  <TextField
                    sx={{ marginTop: 2 }}
                    id={blockOption?.question}
                    placeholder={blockOption?.placeholder}
                    className="textFieldType2"
                    fullWidth
                    multiline={blockOption?.type === 'textarea' || blockOption?.type === 'textFieldMulti'}
                    maxRows={4}
                    value={blockOption?.answer || ''}
                    onChange={(e) => {
                      dataHandler(blockOption?.id, e.target.value);
                    }}
                    onBlur={() => {
                      handleAnswerSubmit(blockOption?.id, blockOption?.answer);
                    }}
                  />
                ) : blockOption?.type === 'multiSelect' || blockOption?.type === 'multiselect' || blockOption?.type === 'tags' ? (
                  <MultiSelectChip
                    allowMulti={true}
                    creatable={blockOption?.type === 'tags'}
                    labelId={blockOption?.question}
                    selectId={blockOption?.question}
                    selectedValue={blockOption?.answer || []}
                    dropDownItems={
                      Array.isArray(blockOption?.options)
                        ? blockOption.options.map((opt) =>
                            typeof opt === 'string'
                              ? { label: opt, value: opt }
                              : opt
                          )
                        : []
                    }
                    handleChange={(value) => {
                      dataHandler(blockOption?.id, value);
                    }}
                    handleBlur={() => {
                      handleAnswerSubmit(blockOption?.id, blockOption?.answer);
                    }}
                  />
                ) : blockOption?.type === 'select' || blockOption?.type === 'dropdown' || blockOption?.type === 'radio' ? (
                  <MultiSelectChip
                    allowMulti={false}
                    labelId={blockOption?.question}
                    selectId={blockOption?.question}
                    selectedValue={blockOption?.answer || []}
                    dropDownItems={
                      Array.isArray(blockOption?.options)
                        ? blockOption.options.map((opt) =>
                            typeof opt === 'string'
                              ? { label: opt, value: opt }
                              : opt
                          )
                        : []
                    }
                    handleChange={(value) => {
                      dataHandler(blockOption?.id, value);
                    }}
                    handleBlur={() => {
                      handleAnswerSubmit(
                        blockOption?.id,
                        blockOption?.answer?.value || blockOption?.answer
                      );
                    }}
                  />
                ) : (
                  <TextField
                    sx={{ marginTop: 2 }}
                    id={blockOption?.question}
                    placeholder={blockOption?.placeholder}
                    className="textFieldType2"
                    fullWidth
                    multiline
                    maxRows={4}
                    value={blockOption?.answer || ''}
                    onChange={(e) => {
                      dataHandler(blockOption?.id, e.target.value);
                    }}
                    onBlur={() => {
                      handleAnswerSubmit(blockOption?.id, blockOption?.answer);
                    }}
                  />
                )}
              </Grid>
            );
          }
          return null;
        })}
      </Grid>
    </Box>
  );
};

export default ConsultantsTabBlock;
